export const FETCH_INTYG_INFO_REQUEST = 'FETCH_INTYG_INFO_REQUEST'
export const FETCH_INTYG_INFO_SUCCESS = 'FETCH_INTYG_INFO_SUCCESS'
export const FETCH_INTYG_INFO_FAILURE = 'FETCH_INTYG_INFO_FAILURE'
